import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from '../CSS/ModalWrapper.module.css';

const ModalWrapper = ({ isOpen, onClose, children, className = '', fullscreenOnMobile = false }) => {
  // Bloquear scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup al desmontar
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Cerrar modal con ESC
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27 && isOpen) {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Determinar las clases CSS a aplicar
  const getModalClasses = () => {
    let classes = styles.modalContent;
    
    // Agregar clase de tamaño si existe
    if (className && styles[className]) {
      classes += ` ${styles[className]}`;
    }
    
    // Agregar clase fullscreen en móvil si está activada
    if (fullscreenOnMobile) {
      classes += ` ${styles.fullscreenMobile}`;
    }
    
    return classes;
  };

  // Usar portal para renderizar directamente en el body
  return createPortal(
    <div 
      className={styles.modalOverlay}
      onClick={onClose}
    >
      <div 
        className={getModalClasses()}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default ModalWrapper;